import '.fq{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fr{padding-left:1.5rem;}.ssr-plugin'
import '.fs{margin:1rem 0;}.ssr-plugin'
import '.ft{color:var(--gray-700);}.ssr-plugin'
import '.fu{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fq fr fs ft fu"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
